var _defs, _rect, _ellipse, _ellipse2, _g, _ellipse3, _ellipse4, _g2, _ellipse5, _ellipse6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoreboundGalaxyBackdrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 700",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "stars",
    width: 137,
    height: 113,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 16,
    r: 1.4,
    fill: "#C2E8FF",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 42,
    r: 1,
    fill: "#D9D5FF",
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 9,
    r: 1.2,
    fill: "#A6F5FF",
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 82,
    r: 1.6,
    fill: "#E2D5FF",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 96,
    r: 1,
    fill: "#B8EFFF",
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 57,
    r: 0.8,
    fill: "#FFFFFF",
    opacity: 0.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "violetNebula"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E58FF",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#6C46D9",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32175A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cyanNebula"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DD8FF",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#237AB6",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15375C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blueArm",
    x1: -1,
    y1: -1,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CEAFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#8CEAFF",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A995FF",
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "violetArm",
    x1: 1,
    y1: -1,
    x2: -1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B996FF",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C8A4FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FE7FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "softGlow",
    x: "-60%",
    y: "-80%",
    width: "220%",
    height: "260%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18
  })), /*#__PURE__*/React.createElement("filter", {
    id: "armGlow",
    x: "-30%",
    y: "-60%",
    width: "160%",
    height: "220%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 700,
    fill: "url(#stars)",
    opacity: 0.55
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 280,
    cy: 168,
    rx: 286,
    ry: 178,
    fill: "url(#violetNebula)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 270,
    cy: 179,
    rx: 220,
    ry: 112,
    fill: "url(#cyanNebula)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(278 172) rotate(-21)",
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 180,
    ry: 45,
    fill: "url(#cyanNebula)",
    filter: "url(#softGlow)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-157-12C-118-91-17-105 52-63C113-26 101 40 54 57C9 73-22 39-8 13C4-9 35-13 52 3",
    stroke: "url(#blueArm)",
    strokeWidth: 16,
    strokeLinecap: "round",
    filter: "url(#armGlow)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157 12C118 91 17 105-52 63C-113 26-101-40-54-57C-9-73 22-39 8-13C-4 9-35 13-52-3",
    stroke: "url(#violetArm)",
    strokeWidth: 12,
    strokeLinecap: "round",
    filter: "url(#armGlow)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-157-12C-118-91-17-105 52-63C113-26 101 40 54 57C9 73-22 39-8 13",
    stroke: "url(#blueArm)",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157 12C118 91 17 105-52 63C-113 26-101-40-54-57C-9-73 22-39 8-13",
    stroke: "url(#violetArm)",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 20,
    fill: "#A5F3FF",
    opacity: 0.5,
    filter: "url(#softGlow)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5,
    fill: "#E7FCFF",
    opacity: 0.8
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 916,
    cy: 182,
    rx: 258,
    ry: 164,
    fill: "url(#cyanNebula)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 924,
    cy: 176,
    rx: 230,
    ry: 132,
    fill: "url(#violetNebula)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(918 179) rotate(17) scale(.82 .82)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 170,
    ry: 42,
    fill: "url(#violetNebula)",
    filter: "url(#softGlow)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-149-10C-112-83-15-96 49-58C106-24 95 37 50 53C8 68-21 36-7 12C4-8 33-12 49 3",
    stroke: "url(#violetArm)",
    strokeWidth: 15,
    strokeLinecap: "round",
    filter: "url(#armGlow)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 10C112 83 15 96-49 58C-106 24-95-37-50-53C-8-68 21-36 7-12C-4 8-33 12-49-3",
    stroke: "url(#blueArm)",
    strokeWidth: 11,
    strokeLinecap: "round",
    filter: "url(#armGlow)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-149-10C-112-83-15-96 49-58C106-24 95 37 50 53C8 68-21 36-7 12",
    stroke: "url(#violetArm)",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 10C112 83 15 96-49 58C-106 24-95-37-50-53C-8-68 21-36 7-12",
    stroke: "url(#blueArm)",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 17,
    fill: "#C7ACFF",
    opacity: 0.55,
    filter: "url(#softGlow)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.5,
    fill: "#F0E9FF",
    opacity: 0.8
  }))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 610,
    cy: 478,
    rx: 315,
    ry: 192,
    fill: "url(#violetNebula)",
    opacity: 0.55
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 680,
    cy: 461,
    rx: 260,
    ry: 150,
    fill: "url(#cyanNebula)",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoreboundGalaxyBackdrop);
export default __webpack_public_path__ + "static/media/coreboundGalaxyBackdrop.cbbc2a8692d13c7d001b1b03c1247e30.svg";
export { ForwardRef as ReactComponent };